import {
  GET_LOYALTY_LIST,
  GET_LOYALTY_LIST_SUCCESS,
  GET_LOYALTY_LIST_ERROR,
  LOYALTY_SINGLE_CUSTOMER_DATA,
  LOYALTY_SINGLE_CUSTOMER_DATA_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_DATA_ERROR,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_ERROR,
  GET_LOYALTY_BALANCES_LIST,
  GET_LOYALTY_BALANCES_LIST_SUCCESS,
  GET_LOYALTY_BALANCES_LIST_ERROR,
  GET_LOYALTY_VOUCHERS_LIST,
  GET_LOYALTY_VOUCHERS_LIST_SUCCESS,
  GET_LOYALTY_VOUCHERS_LIST_ERROR,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_ERROR,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_SUCCESS,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_ERROR,
  CREATE_LOYALTY_TRANSACTION,
  CREATE_LOYALTY_TRANSACTION_SUCCESS,
  CREATE_LOYALTY_TRANSACTION_ERROR,
  CREATE_LOYALTY_VOUCHER_AMOUNT,
  CREATE_LOYALTY_VOUCHER_AMOUNT_SUCCESS,
  CREATE_LOYALTY_VOUCHER_AMOUNT_ERROR,
  LOYALTY_REDEEM_VOUCHER,
  LOYALTY_REDEEM_VOUCHER_SUCCESS,
  LOYALTY_REDEEM_VOUCHER_ERROR,
  VOID_VOUCHER_TRANSACTION,
  VOID_VOUCHER_TRANSACTION_SUCCESS,
  VOID_VOUCHER_TRANSACTION_ERROR,
  RESEND_LOYALTY_VOUCHER_EMAIL,
  RESEND_LOYALTY_VOUCHER_EMAIL_SUCCESS,
  RESEND_LOYALTY_VOUCHER_EMAIL_ERROR,
  LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST,
  LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_ERROR,
  GET_LOYALTY_SPINNER_LIST,
  GET_LOYALTY_SPINNER_LIST_SUCCESS,
  GET_LOYALTY_SPINNER_LIST_ERROR,
  CREATE_LOYALTY_SPINNER,
  CREATE_LOYALTY_SPINNER_SUCCESS,
  CREATE_LOYALTY_SPINNER_ERROR,
  UPDATE_LOYALTY_SPINNER,
  UPDATE_LOYALTY_SPINNER_SUCCESS,
  UPDATE_LOYALTY_SPINNER_ERROR,
  DELETE_LOYALTY_SPINNER,
  DELETE_LOYALTY_SPINNER_SUCCESS,
  DELETE_LOYALTY_SPINNER_ERROR,
  GET_LOYALTY_SPINNER_RENDER,
  GET_LOYALTY_SPINNER_RENDER_SUCCESS,
  GET_LOYALTY_SPINNER_RENDER_ERROR,
  GET_LOYALTY_SPINNER_DATA,
  GET_LOYALTY_SPINNER_DATA_SUCCESS,
  GET_LOYALTY_SPINNER_DATA_ERROR,
  EXECUTE_LOYALTY_SPINNER,
  EXECUTE_LOYALTY_SPINNER_SUCCESS,
  EXECUTE_LOYALTY_SPINNER_ERROR,
} from "./actionType";

// Action for Loyalty List and CRUD

// Loyalty List
export const getLoyaltyList = () => ({
  type: GET_LOYALTY_LIST,
});

export const getLoyaltyListSuccess = (data) => ({
  type: GET_LOYALTY_LIST_SUCCESS,
  payload: data,
});

export const getLoyaltyListError = (error) => ({
  type: GET_LOYALTY_LIST_ERROR,
  payload: error,
});

// Loalty get single customer data post request

export const getLoyaltySingleCustomerData = (id) => ({
  type: LOYALTY_SINGLE_CUSTOMER_DATA,
  payload: id,
});

export const getLoyaltySingleCustomerDataSuccess = (data) => ({
  type: LOYALTY_SINGLE_CUSTOMER_DATA_SUCCESS,
  payload: data,
});

export const getLoyaltySingleCustomerDataError = (error) => ({
  type: LOYALTY_SINGLE_CUSTOMER_DATA_ERROR,
  payload: error,
});

// Loyalty Single Customer balance Search

export const getLoyaltySingleCustomerBalanceSearch = (id) => ({
  type: LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH,
  payload: id,
});

export const getLoyaltySingleCustomerBalanceSearchSuccess = (data) => ({
  type: LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_SUCCESS,
  payload: data,
});

export const getLoyaltySingleCustomerBalanceSearchError = (error) => ({
  type: LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_ERROR,
  payload: error,
});

// GET Loyalty Balances List

export const getLoyaltyBalancesList = () => ({
  type: GET_LOYALTY_BALANCES_LIST,
});

export const getLoyaltyBalancesListSuccess = (data) => ({
  type: GET_LOYALTY_BALANCES_LIST_SUCCESS,
  payload: data,
});

export const getLoyaltyBalancesListError = (error) => ({
  type: GET_LOYALTY_BALANCES_LIST_ERROR,
  payload: error,
});

// GET Loyalty Vouchers List

export const getLoyaltyVouchersList = () => ({
  type: GET_LOYALTY_VOUCHERS_LIST,
});

export const getLoyaltyVouchersListSuccess = (data) => ({
  type: GET_LOYALTY_VOUCHERS_LIST_SUCCESS,
  payload: data,
});

export const getLoyaltyVouchersListError = (error) => ({
  type: GET_LOYALTY_VOUCHERS_LIST_ERROR,
  payload: error,
});

// GET Loyalty Dashboard Recent Activity List

export const getLoyaltyDashboardRecentActivityList = () => ({
  type: GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST,
});

export const getLoyaltyDashboardRecentActivityListSuccess = (data) => ({
  type: GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_SUCCESS,
  payload: data,
});

export const getLoyaltyDashboardRecentActivityListError = (error) => ({
  type: GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_ERROR,
  payload: error,
});

// Search Loyalty Dashboard Report Data

export const searchLoyaltyDashboardReportData = (data) => ({
  type: SEARCH_LOYALTY_DASHBOARD_REPORT_DATA,
  payload: data,
});

export const searchLoyaltyDashboardReportDataSuccess = (data) => ({
  type: SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_SUCCESS,
  payload: data,
});

export const searchLoyaltyDashboardReportDataError = (error) => ({
  type: SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_ERROR,
  payload: error,
});

// Create Loyalty Transaction

export const createLoyaltyTransaction = (data) => ({
  type: CREATE_LOYALTY_TRANSACTION,
  payload: data,
});

export const createLoyaltyTransactionSuccess = (data) => ({
  type: CREATE_LOYALTY_TRANSACTION_SUCCESS,
  payload: data,
});

export const createLoyaltyTransactionError = (error) => ({
  type: CREATE_LOYALTY_TRANSACTION_ERROR,
  payload: error,
});

// Create Loyalty Voucher Amount

export const createLoyaltyVoucherAmount = (data) => ({
  type: CREATE_LOYALTY_VOUCHER_AMOUNT,
  payload: data,
});

export const createLoyaltyVoucherAmountSuccess = (data) => ({
  type: CREATE_LOYALTY_VOUCHER_AMOUNT_SUCCESS,
  payload: data,
});

export const createLoyaltyVoucherAmountError = (error) => ({
  type: CREATE_LOYALTY_VOUCHER_AMOUNT_ERROR,
  payload: error,
});

// Loyalty Redeem Voucher

export const loyaltyRedeemVoucher = (data) => ({
  type: LOYALTY_REDEEM_VOUCHER,
  payload: data,
});

export const loyaltyRedeemVoucherSuccess = (data) => ({
  type: LOYALTY_REDEEM_VOUCHER_SUCCESS,
  payload: data,
});

export const loyaltyRedeemVoucherError = (error) => ({
  type: LOYALTY_REDEEM_VOUCHER_ERROR,
  payload: error,
});

// Void Voucher Transaction

export const voidVoucherTransaction = (data) => ({
  type: VOID_VOUCHER_TRANSACTION,
  payload: data,
});

export const voidVoucherTransactionSuccess = (data) => ({
  type: VOID_VOUCHER_TRANSACTION_SUCCESS,
  payload: data,
});

export const voidVoucherTransactionError = (error) => ({
  type: VOID_VOUCHER_TRANSACTION_ERROR,
  payload: error,
});

// Loyalty Vouhcer Resend EMail

export const resendLoyaltyVoucherEmail = (data) => ({
  type: RESEND_LOYALTY_VOUCHER_EMAIL,
  payload: data,
});

export const resendLoyaltyVoucherEmailSuccess = (data) => ({
  type: RESEND_LOYALTY_VOUCHER_EMAIL_SUCCESS,
  payload: data,
});

export const resendLoyaltyVoucherEmailError = (error) => ({
  type: RESEND_LOYALTY_VOUCHER_EMAIL_ERROR,
  payload: error,
});

// Loyalty Single Customer Voucher List

export const getLoyaltySingleCustomerVoucherList = (id) => ({
  type: LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST,
  payload: id,
});

export const getLoyaltySingleCustomerVoucherListSuccess = (data) => ({
  type: LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_SUCCESS,
  payload: data,
});

export const getLoyaltySingleCustomerVoucherListError = (error) => ({
  type: LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_ERROR,
  payload: error,
});

// Loyalty Spinner List
export const getLoyaltySpinnerList = () => ({
  type: GET_LOYALTY_SPINNER_LIST,
});

export const getLoyaltySpinnerListSuccess = (data) => ({
  type: GET_LOYALTY_SPINNER_LIST_SUCCESS,
  payload: data,
});

export const getLoyaltySpinnerListError = (error) => ({
  type: GET_LOYALTY_SPINNER_LIST_ERROR,
  payload: error,
});

// Create Loyalty Spinner
export const createLoyaltySpinner = (data) => ({
  type: CREATE_LOYALTY_SPINNER,
  payload: data,
});

export const createLoyaltySpinnerSuccess = (data) => ({
  type: CREATE_LOYALTY_SPINNER_SUCCESS,
  payload: data,
});

export const createLoyaltySpinnerError = (error) => ({
  type: CREATE_LOYALTY_SPINNER_ERROR,
  payload: error,
});

// Update Loyalty Spinner
export const updateLoyaltySpinner = (data) => ({
  type: UPDATE_LOYALTY_SPINNER,
  payload: data,
});

export const updateLoyaltySpinnerSuccess = (data) => ({
  type: UPDATE_LOYALTY_SPINNER_SUCCESS,
  payload: data,
});

export const updateLoyaltySpinnerError = (error) => ({
  type: UPDATE_LOYALTY_SPINNER_ERROR,
  payload: error,
});

// Delete Loyalty Spinner
export const deleteLoyaltySpinner = (data) => ({
  type: DELETE_LOYALTY_SPINNER,
  payload: data,
});

export const deleteLoyaltySpinnerSuccess = (data) => ({
  type: DELETE_LOYALTY_SPINNER_SUCCESS,
  payload: data,
});

export const deleteLoyaltySpinnerError = (error) => ({
  type: DELETE_LOYALTY_SPINNER_ERROR,
  payload: error,
});

// Get Loyalty Spinner Render Data
export const getLoyaltySpinnerRender = (id) => ({
  type: GET_LOYALTY_SPINNER_RENDER,
  payload: id,
});

export const getLoyaltySpinnerRenderSuccess = (data) => ({
  type: GET_LOYALTY_SPINNER_RENDER_SUCCESS,
  payload: data,
});

export const getLoyaltySpinnerRenderError = (error) => ({
  type: GET_LOYALTY_SPINNER_RENDER_ERROR,
  payload: error,
});

// Get Loyalty Spinner Data
export const getLoyaltySpinnerData = (id) => ({
  type: GET_LOYALTY_SPINNER_DATA,
  payload: id,
});

export const getLoyaltySpinnerDataSuccess = (data) => ({
  type: GET_LOYALTY_SPINNER_DATA_SUCCESS,
  payload: data,
});

export const getLoyaltySpinnerDataError = (error) => ({
  type: GET_LOYALTY_SPINNER_DATA_ERROR,
  payload: error,
});

// Execute Loyalty Spinner
export const executeLoyaltySpinner = (data) => ({
  type: EXECUTE_LOYALTY_SPINNER,
  payload: data,
});

export const executeLoyaltySpinnerSuccess = (data) => ({
  type: EXECUTE_LOYALTY_SPINNER_SUCCESS,
  payload: data,
});

export const executeLoyaltySpinnerError = (error) => ({
  type: EXECUTE_LOYALTY_SPINNER_ERROR,
  payload: error,
});
